import { createFileRoute } from "@tanstack/react-router";

import DashboardPage from "@/components/pages/DashboardPage";

type DashboardSearch = {
  date?: string;
  /** Page period scoping the summary cards and Insights (NAU-262) */
  period?: string;
  tab?: string;
  /** "today" shows the per-day tabbed operational view; default is the overview */
  view?: string;
};

export const Route = createFileRoute("/_authenticated/dashboard")({
  validateSearch: (search: Record<string, unknown>): DashboardSearch => ({
    date: (search.date as string) || undefined,
    period: (search.period as string) || undefined,
    tab: (search.tab as string) || undefined,
    view: (search.view as string) || undefined,
  }),
  component: DashboardPage,
});
